import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { headerAvatar } from "../../../assets/img";
// import "../../../assets/scss/1-helpers";
import { MagnifyingGlass } from "react-loader-spinner";
import { FaRegCirclePlay } from "react-icons/fa6";
import { listNFTs } from "../../../hooks/NFTHook";
const walletAddress = localStorage.getItem('WalletAddress');

const DynamicCollectionCard = ({
  CollectionLink,
  marketItem,
  collectionName,
  collectionLogo,
  owner,
  totalMarketItem
}) => {

  const [isHovered, setIsHovered] = useState(false);
  const truncate = (text, length) => {
    if (text?.length > length) return `${text?.substring(0, length)}...`;
    return text;
  };

  const renderMedia = (item, key) => {
    
    if (!item || !item.imageUri) {
      return (
        <div key={key} className="no-asset d-flex align-item-center justify-content-between" style={{ borderRadius: "18px", background: "gray", height: "100%", color: "white" }}>
          <MagnifyingGlass
            visible={true}
            height="150"
            width="150"
            ariaLabel="magnifying-glass-loading"
            wrapperStyle={{}}
            wrapperClass="magnifying-glass-wrapper"
            glassColor="#c0efff"
            color="#e15b64"
          />
        </div>
      );
    }

    const TypeofAsset = item.assetType;
    return TypeofAsset?.split("/")[0] !== "image" ? (
      <div
        className="video-wrapper"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <video
          key={key}
          style={{ borderRadius: "18px" }}
          muted
          loop
          playsInline
          className={`video ${isHovered ? "playing" : ""}`}
          onMouseEnter={(e) => e.target.play()}
          onMouseLeave={(e) => e.target.pause()}
        >
          <source src={item.imageUri} type={item.type} />
          Your browser does not support the video tag.
        </video>
        {!isHovered && <div className="pause-overlay"><FaRegCirclePlay /></div>}
      </div>
    ) : (
      <img
        key={key}
        src={item.imageUri}
        alt={`Preview ${key}`}
        style={{ borderRadius: "18px" }}
      />
    );
  };

  const renderMediaPreviews = () => {
    if (marketItem.length === 0) {
      return (
        <div className="blank-placeholder">
          <img src={collectionLogo} alt="mt-collection" style={{ borderRadius: "18px", height: "100%", width: "100%" }} />

        </div>
      );
    }


    if (marketItem.length === 1) {
      return (
        <div className="single-item">
          {renderMedia(marketItem[0], 0)}
        </div>
      );
    } else if (marketItem.length === 2) {
      return (
        <div className="grid-two">
          {marketItem.map((item, index) => (
            <div key={index} className="grid-item">
              {renderMedia(item, index)}
            </div>
          ))}
        </div>
      );
    } else if (marketItem.length === 3) {
      return (
        <div className="grid-three">
          {marketItem.map((item, index) => (
            <div key={index} className="grid-item">
              {renderMedia(item, index)}
            </div>
          ))}
        </div>
      );
    } else {
      return (
        <div className="grid-four">
          {marketItem.map((item, index) => (
            <div key={index} className="grid-item">
              {renderMedia(item, index)}
            </div>
          ))}
        </div>
      );

      
    }
  };


  return (
    <div
    className={`collections space-y-10 mb-30 ${isHovered ? "hovered" : ""}`}
    onMouseEnter={() => setIsHovered(true)}
    onMouseLeave={() => setIsHovered(false)}
  >
    <div className="collections_item collections_item card-hover-effect" style={{ position: "relative" }}>
      <Link to={CollectionLink} className="images-box space-y-10" style={{ position: "relative" }}>
        {renderMediaPreviews()}
  
        {totalMarketItem > 4 && (
          <div
            style={{
              position: "absolute",
              bottom: "10px", // Position at the bottom-right corner of the image
              right: "10px",
              background: "#183b56",
              color: "white",
              borderRadius: "50%",
              height:"40px",
              width:"40px",
              fontSize: "20px",
              textAlign:"center",
              fontWeight: "bold",
              paddingTop:"5px",
              zIndex: 10,
            }}
          >
            + {totalMarketItem - 4} {/* Display count as total NFTs - 4 */}
          </div>
        )}
      </Link>
  
      {/* Card Footer */}
      <div className="pt-3">
        <div className="collections_footer justify-content-between">
          <div>
            <div className="avatars">
              <img src={collectionLogo} alt="Collection Logo" className="avatar avatar-md" />
              <div>
                <h5 className="collection_title" style={{ marginLeft: "10px" }}>
                  <Link to="/profile">
                    {isHovered ? collectionName : truncate(collectionName, 10)}
                  </Link>
                </h5>
                <p style={{ marginLeft: "10px" }}>
                {totalMarketItem} Items
                </p>
              </div>
            </div>
          </div>
          {owner && (
            <div className="">
              <div>
                <span className="color_text txt_md">Creator</span>
              </div>
              <div className="creators space-x-0">
              <div className="avatars space-x-5">
                  <Link to={marketItem[0]?.creator?.walletAddress !== walletAddress ? `/otherProfile/${marketItem[0]?.creator?.walletAddress}` : "/profile"}>
                    <img
                      src={marketItem[0]?.creator?.userId?.profilePicture}
                      alt="Creator Avatar"
                      className="avatar avatar-sm"
                    />
                  </Link>
                </div>
                <Link to={marketItem[0]?.creator?.walletAddress !== walletAddress ? `/otherProfile/${marketItem[0]?.creator?.walletAddress}` : "/profile"}>
                <p className="avatars_name txt_sm">
                    {isHovered ? marketItem[0]?.creator?.userId?.name : truncate(marketItem[0]?.creator?.userId?.name, 8)}
                  </p>
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
  
  );
};  
   
DynamicCollectionCard.propTypes = {
  CollectionLink: PropTypes.string,
  marketItem: PropTypes.array.isRequired, // Ensure array is passed
  ownerDetails: PropTypes.object,
  collectionName: PropTypes.string,
  collectionLogo: PropTypes.string,
  contractAddress: PropTypes.string,
  owner:PropTypes.bool,
  totalMarketItem:PropTypes.number
};

DynamicCollectionCard.defaultProps = {
  CollectionLink: "#",
  marketItem: [],
  ownerDetails: null,
  collectionName: "Unknown",
  collectionLogo:headerAvatar,
  owner:true,
  contractAddress:null,
  totalMarketItem:0
};

export default DynamicCollectionCard;